export interface Emailadres {
    id: string;
    adres: string;
    klant_prospect_id: string;
    is_voorkeur: boolean;
    classificatie_code: number;
    classificatie_verklaring: string;
    status: AdresStatus;
    gewijzigd_op: string;
    lsm_session_id: string;
    authentication_task_id: string;
    diensten?: DienstType[];
}

export interface Telefoonnummer {
    id: string;
    nummer: string;
    klant_prospect_id: string;
    is_voorkeur: boolean;
    type_code: number;
    type_verklaring: string;
    classificatie_code: number;
    classificatie_verklaring: string;
    status: AdresStatus;
    gewijzigd_op: string;
    lsm_session_id: string;
    authentication_task_id: string;
    diensten?: DienstType[];
}

export interface LijstVanEmailadressen {
    emailadressen?: Emailadres[];
}

export interface LijstVanTelefoonnummers {
    telefoonnummers?: Telefoonnummer[];
}

export interface LijstVanDiensten {
    diensten?: DienstType[];
}

export enum AdresStatus {
    INACTIEF = 'inactief',
    IN_AFWACHTING = 'in_afwachting',
    ACTIEF = 'actief',
    IN_AFWACHTING_VAN_VERANDERING = 'in_afwachting_van_verandering',
    GEVALIDEERD = 'gevalideerd'
}

export enum DienstType {
    ONBEKEND = 'onbekend',
    TRANSACTIE_ALARM_LAAG = 'transactie_alarm_laag',
    TRANSACTIE_ALARM_HOOG = 'transactie_alarm_hoog',
    TEGENREKENING_TRANSACTIE_ALARM = 'tegenrekening_transactie_alarm',
    URGENTE_TRANSACTIE_ALARM = 'urgente_transactie_alarm',
    DIGICODE = 'digicode',
    BINCK_ORDER_ALARM = 'binck_order_alarm',
    AFGEWEZEN_BETALINGEN = 'afgewezen_betalingen'
}
